module.exports = __webpack_public_path__ + "static/img/l2.d2990ad1.jpg";